<template>
  <div>
    <div v-if="fill_info == '' && form.fields.length > 0">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-title">{{ form.name }}</div>
        </div>
        <div class="col-xs-12">
          <div class="info-box download">
            <a target="_blank" href="assets/files/nemzeti_felsooktatasi_osztondij_2025_palyazati_felhivas.pdf" title="Pályázati felhívás letöltés">
              <span class="highlight">Pályázati felhívás</span> letöltés
            </a>
          </div>
          <div class="info-box download">
            <a target="_blank" href="assets/files/nemzeti_felsooktatasi_osztondij_2025_palyazati_utmutato.pdf" title="Pályázati útmutató letöltés">
              <span class="highlight">Pályázati útmutató</span> letöltés
            </a>
          </div>
          <div class="info-box download">
            <a target="_blank" href="assets/files/nemzeti_felsooktatasi_osztondij_2025_osztondijindexek.pdf" title="Ösztöndíjindex tájékoztató letöltés">
              <span class="highlight">Ösztöndíjindex tájékoztató</span> letöltés
            </a>
          </div>
        </div>

        <div class="col-xs-12">
          <h5 style="margin-top: 0px;" class="form-block-title">
            Alapadatok
          </h5>
        </div>
        <div class="col-xs-6">
          <div class="form-group">
            <label class="form-label">Név</label>
            <input disabled="disabled" type="text" name="nev" class="form-control" v-model="form.hallgato_alapadatok.nev"/>
          </div>
          <div class="form-group">
            <label class="form-label">Neptun azonosító</label>
            <input disabled="disabled" type="text" name="neptunkod" class="form-control" v-model="form.hallgato_alapadatok.neptunkod"/>
          </div>
          <div class="form-group">
            <label class="form-label">Szak</label>
            <p class="form-group-info">(A szak képesítési követelményeit meghatározó Korm. rendelet szerinti megnevezés).</p>
            <input disabled="disabled" type="text" name="szak" class="form-control" v-model="form.hallgato_alapadatok.szak"/>
          </div>
          <div class="form-group">
            <label class="form-label">Aktív félévek száma</label>
            <input disabled="disabled" type="text" name="aktiv_felevek_szama" class="form-control" v-model="form.hallgato_alapadatok.aktiv_felevek_szama"/>
          </div>
        </div>
        <div class="col-xs-6">
          <div class="form-group">
            <label class="form-label">Születési hely, idő</label>
            <input disabled="disabled" type="text" name="szulhelyido" class="form-control" v-model="form.hallgato_alapadatok.szulhelyido"/>
          </div>
          <div class="form-group">
            <label class="form-label">Kar</label>
            <input disabled="disabled" type="text" name="kar" class="form-control" v-model="form.hallgato_alapadatok.kar"/>
          </div>
          <div class="form-group">
            <label class="form-label">Képzés szintje</label>
            <p class="form-group-info">&nbsp;</p>
            <input disabled="disabled" type="text" name="kepzes_szint" class="form-control" v-model="form.hallgato_alapadatok.kepzes_szint"/>
          </div>
          <div class="form-group">
            <label class="form-label">Megszerzett kreditpontok száma</label>
            <input disabled="disabled" type="text" name="kar" class="form-control" v-model="form.hallgato_alapadatok.kreditek_szama"/>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <h5 class="form-block-title">
            Tanulmányok
            <div class="form-block-point">
              <span>{{ tanulmanyok_pont }} / {{ tanulmanyok_max_pont }}</span> pont
            </div>
          </h5>
          <comboboxV2 v-on:onChange="(index) => { szakValt(index, true, true); }" label="Szakok" id="szak_id" name="szak_id" :options="szak_combo_opts" v-model="szak_combo_index"/>
          <h6>Az előző {{ elozo_tanev }} tanév átlaga</h6>
        </div>
        <div class="col-xs-3">
          <div class="form-group">
            <label class="form-label">I. félév</label>
            <input disabled="disabled" type="text" name="tanulm_ef" class="form-control" v-model="form.hallgato_atlagok.felev1"/>
          </div>
        </div>
        <div class="col-xs-3">
          <div class="form-group">
            <label class="form-label">II. félév</label>
            <input disabled="disabled" type="text" name="tanulm_mf" class="form-control" v-model="form.hallgato_atlagok.felev2"/>
          </div>
        </div>
        <div class="col-xs-3">
          <div class="form-group">
            <label class="form-label">Átlag</label>
            <input disabled="disabled" type="text" name="tanulm_atlag" class="form-control" v-model="form.hallgato_atlagok.atlag"/>
          </div>
        </div>
        <div class="col-xs-12">
          <h6>Nyelvvizsgák</h6>
          <div class="info-box warning">
            Kizárólag a Neptun rendszerben a Tanulmányi Ügyintéző által rögzített nyelvvizsgá(k)hoz van lehetőség mellékletként a bizonyítvány másolatának feltöltésére.
          </div>
          <div class="row">
            <div class="col-xs-12">
              <UploadHandlerWithComboAddRemove ref="nyelvtudas" :block_once="true" :block_point="sor_pontCalc('nyelvtudas')" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'nyelvtudas'); }" :accepted_files="getFieldByName('nyelvtudas').accepted_files" :options="getFieldByName('nyelvtudas').options" :id="getFieldByName('nyelvtudas').name" :label="getFieldByName('nyelvtudas').label" :name="getFieldByName('nyelvtudas').name"/>
            </div>
          </div>
        </div>

        <div class="col-xs-12">
          <h5 class="form-block-title">
            Szakmai tevékenység
            <div class="form-block-point">
              <span>{{ szakmaitevekenyseg_pont }} / {{ szakmaitevekenyseg_max_pont }}</span> pont
            </div>
          </h5>
          <div class="info-box warning">
            Minden, pályázati útmutatóban megjelölt tevékenységet alátámasztó dokumentum feltöltésével szükséges igazolni.
          </div>
          <div class="row">
            <div class="col-xs-12">
              <UploadHandlerWithComboAddRemove :autoFill="true" ref="st1" :enable_block_delete="false" :hide_all_options="true" :block_point="sor_pontok.st1" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'st1'); }" :accepted_files="getFieldByName('st1').accepted_files" :options="getFieldByName('st1').options" :id="getFieldByName('st1').name" :label="getFieldByName('st1').label" :name="getFieldByName('st1').name"/>
            </div>
            <div class="col-xs-12">
              <UploadHandlerWithComboAddRemove :autoFill="true" ref="st2" :enable_block_delete="false" :hide_all_options="true" :block_point="sor_pontok.st2" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'st2'); }" :accepted_files="getFieldByName('st2').accepted_files" :options="getFieldByName('st2').options" :id="getFieldByName('st2').name" :label="getFieldByName('st2').label" :name="getFieldByName('st2').name"/>
            </div>
            <div class="col-xs-12">
              <UploadHandlerWithComboAddRemove ref="st3" :block_point="sor_pontok.st3" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'st3'); }" :accepted_files="getFieldByName('st3').accepted_files" :options="getFieldByName('st3').options" :id="getFieldByName('st3').name" :label="getFieldByName('st3').label" :name="getFieldByName('st3').name"/>
            </div>
            <div class="col-xs-12">
              <UploadHandlerWithComboAddRemove ref="st4" :block_point="sor_pontok.st4" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'st4'); }" :accepted_files="getFieldByName('st4').accepted_files" :options="getFieldByName('st4').options" :id="getFieldByName('st4').name" :label="getFieldByName('st4').label" :name="getFieldByName('st4').name"/>
            </div>
            <div class="col-xs-12">
              <UploadHandlerWithComboAddRemove ref="st5" :block_point="sor_pontok.st5" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'st5'); }" :accepted_files="getFieldByName('st5').accepted_files" :options="getFieldByName('st5').options" :id="getFieldByName('st5').name" :label="getFieldByName('st5').label" :name="getFieldByName('st5').name"/>
            </div>
            <div class="col-xs-12">
              <UploadHandlerWithComboAddRemove ref="st6" :autoFill="true" :enable_block_delete="false" :hide_all_options="true" :block_point="sor_pontok.st6" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'st6'); }" :accepted_files="getFieldByName('st6').accepted_files" :options="getFieldByName('st6').options" :id="getFieldByName('st6').name" :label="getFieldByName('st6').label" :name="getFieldByName('st6').name"/>
            </div>
            <div class="col-xs-12">
              <UploadHandlerWithComboAddRemove ref="st7" :block_point="sor_pontok.st7" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'st7'); }" :accepted_files="getFieldByName('st7').accepted_files" :options="getFieldByName('st7').options" :id="getFieldByName('st7').name" :label="getFieldByName('st7').label" :name="getFieldByName('st7').name"/>
            </div>
            <div class="col-xs-12">
              <UploadHandlerWithComboAddRemove ref="st8" :block_point="sor_pontok.st8" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'st8'); }" :accepted_files="getFieldByName('st8').accepted_files" :options="getFieldByName('st8').options" :id="getFieldByName('st8').name" :label="getFieldByName('st8').label" :name="getFieldByName('st8').name"/>
            </div>
          </div>
        </div>

        <div class="col-xs-12">
          <h5 class="form-block-title">
            Közéleti, sport és egyéb tevékenység
            <div class="form-block-point">
              <span>{{ kozelet_sport_pont }} / {{ kozelet_sport_max_pont }}</span> pont
            </div>
          </h5>
          <div class="info-box warning">
            Minden, pályázati útmutatóban megjelölt tevékenységet alátámasztó dokumentum feltöltésével szükséges igazolni.
          </div>
          <div class="row">
            <div class="col-xs-12">
              <UploadHandlerWithComboAddRemove ref="ks1" :autoFill="true" :enable_block_delete="false" :hide_all_options="true" :block_point="sor_pontok.ks1" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'ks1'); }" :accepted_files="getFieldByName('ks1').accepted_files" :options="getFieldByName('ks1').options" :id="getFieldByName('ks1').name" :label="getFieldByName('ks1').label" :name="getFieldByName('ks1').name"/>
            </div>
            <div class="col-xs-12">
              <UploadHandlerWithComboAddRemove ref="ks2" :autoFill="true" :enable_block_delete="false" :block_point="sor_pontok.ks2" :hide_all_options="true" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'ks2'); }" :accepted_files="getFieldByName('ks2').accepted_files" :options="getFieldByName('ks2').options" :id="getFieldByName('ks2').name" :label="getFieldByName('ks2').label" :name="getFieldByName('ks2').name"/>
            </div>
            <div class="col-xs-12">
              <UploadHandlerWithComboAddRemove ref="ks3" :autoFill="true" :enable_block_delete="false" :block_point="sor_pontok.ks3" :hide_all_options="true" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'ks3'); }" :accepted_files="getFieldByName('ks3').accepted_files" :options="getFieldByName('ks3').options" :id="getFieldByName('ks3').name" :label="getFieldByName('ks3').label" :name="getFieldByName('ks3').name"/>
            </div>
            <div class="col-xs-12">
              <UploadHandlerWithComboAddRemove ref="ks4" :autoFill="true" :enable_block_delete="false" :hide_all_options="true" :block_point="sor_pontok.ks4" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'ks4'); }" :accepted_files="getFieldByName('ks4').accepted_files" :options="getFieldByName('ks4').options" :id="getFieldByName('ks4').name" :label="getFieldByName('ks4').label" :name="getFieldByName('ks4').name"/>
            </div>
            <div class="col-xs-12">
              <UploadHandlerWithComboAddRemove ref="ks5" :block_point="sor_pontok.ks5" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'ks5'); }" :accepted_files="getFieldByName('ks5').accepted_files" :options="getFieldByName('ks5').options" :id="getFieldByName('ks5').name" :label="getFieldByName('ks5').label" :name="getFieldByName('ks5').name"/>
            </div>
            <div class="col-xs-12">
              <UploadHandlerWithComboAddRemove ref="ks6" :block_point="sor_pontok.ks6" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'ks6'); }" :accepted_files="getFieldByName('ks6').accepted_files" :options="getFieldByName('ks6').options" :id="getFieldByName('ks6').name" :label="getFieldByName('ks6').label" :name="getFieldByName('ks6').name"/>
            </div>
            <div class="col-xs-12">
              <UploadHandlerWithComboAddRemove ref="ks7" :block_point="sor_pontok.ks7" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'ks7'); }" :accepted_files="getFieldByName('ks7').accepted_files" :options="getFieldByName('ks7').options" :id="getFieldByName('ks7').name" :label="getFieldByName('ks7').label" :name="getFieldByName('ks7').name"/>
            </div>
          </div>
        </div>

        <div class="col-xs-12">
          <div style="display: flex; justify-content: space-between; align-items: center">
            <button v-on:click="save(0)" :disabled="!save_enabled" type="button" name="kuld" class="button">Mentés</button>
            <button v-on:click="save(1)" :disabled="!save_enabled" type="button" name="kuld" class="button">Véglegesít</button>
            <div class="form-total-point">
              <span>{{ ossz_pont }} / {{ ossz_max_pont }}</span> pont
            </div>
          </div>
        </div>

      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-xs-12">
          <div class="form-title">{{ form.name }}</div>
          <div class="article-text" v-html="fill_info"></div>

          <div v-if="remedy">
            <div style="margin-top: 30px;" class="info-box warning">
              Figyelem! Az elbírálással kapcsolatban fellebezést nyújthat be.
            </div>
            <a href="javascript:void(0)" title="" v-on:click="remedy_popup = true;" class="button">Fellebezés</a>
          </div>

          <div style="margin-top: 40px;" class="info-box" v-if="remedy_user != false">
            <div class="title">Fellebezés</div>
            <div><span class="highlight">{{ remedy_user.name }}</span> ({{remedy_user.created}})</div>
            <div style="padding-top: 20px;" v-html="$root.nl2br(remedy_user.msg)">
            </div>
          </div>

          <div style="margin-top: 20px;" class="info-box" v-if="remedy_admin != false">
            <div class="title">Fellebezés válasz</div>
            <div><span class="highlight">{{ remedy_admin.name }}</span> ({{remedy_admin.created}})</div>
            <div style="padding-top: 20px;" v-html="$root.nl2br(remedy_admin.msg)">
            </div>
          </div>
        </div>
      </div>
    </div>
    <Fellebezes v-on:close="(final) => { remedy_popup = false; if (final) remedy = false; }" v-if="remedy && $route.query.id != undefined && remedy_popup" :form_id="$route.query.id"/>
  </div>
</template>

<script>
import Vue from 'vue';
import Fellebezes from './fellebezes.vue';

export default {
  components: {
    Fellebezes
  },
  data: function() {
    return {
      fill_info: '',
      pdf_filename: '',
      errors: [],
      save_enabled: false,
      tanulmanyok_max_pont: 700,
      idegennyelv_max_pont: 200,
      szakmaitevekenyseg_max_pont: 200,
      kozelet_sport_max_pont: 0,
      ossz_max_pont: 0,
      tanulmanyok_pont: 0,
      osztondijindex_pont: 0,
      idegennyelv_pont: 0,
      szakmaitevekenyseg_pont: 0,
      kozelet_sport_pont: 0,
      ossz_pont: 0,
      hallgato_alapadatok_t: [],
      hallgato_atlagok_t: [],
      szak_combo_opts: [],
      szak_combo_index: 0,
      remedy: false,
      remedy_popup: false,
      remedy_admin: false,
      remedy_user: false,
      sor_pontok: {
        st1: 0,
        st2: 0,
        st3: 0,
        st4: 0,
        st5: 0,
        st6: 0,
        st7: 0,
        st8: 0,
        ks1: 0,
        ks2: 0,
        ks3: 0,
        ks4: 0,
        ks5: 0,
        ks6: 0,
        ks7: 0
      },
      form: {
        name: '',
        fields: [],
        values: {},
        hallgato_alapadatok: {},
        hallgato_atlagok: {},
        prev_academic_year: ''
      }
    }
  },
  mounted: function() {
  	var _this = this;
    this.tanulmanyok_pontCalc();
    this.max_ossz_pontCalc();
    this.kozelet_sport_max_pontCalc();
    this.form.id = this.$route.query.id;

    this.$root.ajax('form/nemzeti_felsooktatasi_osztondij_kitoltes_ellenorzes/' + this.$route.query.id, {
      success: function(response) {
        if (response.error) {
          swal('Hiba!',response.error,'error');
        } else {
          if (response.redirect_path != undefined) {
            _this.$router.push({path: response.redirect_path});
            return;
          }

          _this.fill_info = response.fill_info;
          _this.form.name = response.form_name;
          _this.form.academic_year = response.academic_year;
          _this.remedy = response.remedy;

          if (response.remedy_admin != undefined)
            _this.remedy_admin = response.remedy_admin;

          if (response.remedy_user != undefined)
            _this.remedy_user = response.remedy_user;

          response.form_fields.map(function(ff) {
            ff.options.map(function(opt) {
              opt.show = 1;
            });
            _this.form.values[ff.name] = "";
          });

          _this.form.fields = response.form_fields;

          _this.form.hallgato_alapadatok = response.hallgato_alapadatok;
          _this.form.hallgato_atlagok = response.hallgato_atlagok;
          _this.hallgato_alapadatok_t = response.hallgato_alapadatok_t;
          _this.hallgato_atlagok_t = response.hallgato_atlagok_t;

          // Szak választó combó adatok a hallgató alapadatok tömbből
          _this.hallgato_alapadatok_t.map(function(h, i) {
            _this.szak_combo_opts.push({
              value: i,
              label: h.szak + ' ' + h.kepzes_szint + ' (' + h.tagozat + ')'
            });
          });

          // Ösztöndíj index pont beállítása
          _this.osztondijindex_pont = _this.form.hallgato_atlagok.atlag * 100;

          _this.form.fields.map(function(field) {
            if(field.name == 'nyelvtudas') {
              field.options = field.options.concat(response.nyelvtudas);
            }
          });

          // TMDK, OTDK lekérdezése, akkor ha nincs mentett adat
          if (response.saved_data == undefined) {
            Vue.nextTick(function() {
              _this.tmdkLekerdezese();
              _this.otdkLekerdezese();
            });
          }

          // Automatikus kombó beállítás (tisztségviselő, tag, automatikus beállítása)
          setTimeout(function() {
            _this.form.fields.map(function(field) {
              if (field.member_auto_select == 1 && field.options != undefined && field.name != "st1" && field.name != 'st2') {
                var has_autoselect = false;

                field.options.map(function(option) {
                  if (option.tagsagok != undefined) {
                    option.tagsagok.map((tagsag) => {
                      _this.$refs[field.name].addBlockFromOuter(option.value, tagsag + ' (' + option.text + ')', ['ktr_autofill.jpg']);
                      has_autoselect = true;
                    });
                  }
                });
                // Nincs kiválasztva egy mező sem automatikusan, akkor egy üzenet jelenik meg
                if (!has_autoselect)
                  _this.$refs[field.name].setNoOptionMsg('Nyilvántartásban nem szerepel.');
              }
            });
          }, 0);

          setTimeout(function() {
            // Korábbi mentés visszatöltése
            if (response.saved_data != undefined && response.saved_data != '') {
              // Kiválasztott szakkódot visszaállítja
              _this.hallgato_alapadatok_t.map(function(item, i) {
                if (item.szakkod == response.saved_data.szakkod) {
                  _this.szak_combo_index = i;
                  _this.szakValt(i, false, false);
                }
              });

              // Űrlap adatok visszatöltése
              _this.form.values = response.saved_data.values;

              // UploadHandlerWithComboAddRemove blokkok visszatöltése
              response.saved_data.upload_blocks.map(function(upload_block) {
                Vue.nextTick(function() {
                  if (_this.$refs[upload_block.id] != undefined) {
                    _this.$refs[upload_block.id].removeAllBlock(); // Ne legyen duplikált blokk, ha az automatikus combó állításnál egyszer már be lett állítva
                    _this.$refs[upload_block.id].setBlocks(upload_block.blocks);

                    // TMDK
                    if (upload_block.id == "st2" && upload_block.blocks.length == 0) {
                      _this.$refs["st2"].setNoOptionMsg('Nyilvántartásban nem szerepel.');
                    }

                    // OTDK
                    if (upload_block.id == "st1" && upload_block.blocks.length == 0) {
                      _this.$refs["st1"].setNoOptionMsg('Nyilvántartásban nem szerepel.');
                    }

                    // Egyéb kiemelkedő szakmai tevékenység
                    if (upload_block.id == "st6" && upload_block.blocks.length == 0) {
                      _this.$refs["st6"].setNoOptionMsg('Nyilvántartásban nem szerepel.');
                    }

                    // EHÖK, ill. Kari HÖK tevékenységében való részvétel
                    if (upload_block.id == "ks1" && upload_block.blocks.length == 0) {
                      _this.$refs["ks1"].setNoOptionMsg('Nyilvántartásban nem szerepel.');
                    }

                    // Országos vagy nemzetközi hallgatói szervezet (pl. HÖOK)
                    if (upload_block.id == "ks2" && upload_block.blocks.length == 0) {
                      _this.$refs["ks2"].setNoOptionMsg('Nyilvántartásban nem szerepel.');
                    }

                    // Szenátusban, ill. Kari Tanácsban való részvétel
                    if (upload_block.id == "ks3" && upload_block.blocks.length == 0) {
                      _this.$refs["ks3"].setNoOptionMsg('Nyilvántartásban nem szerepel.');
                    }

                    // HÖK-höz tartozó hallgatói szervezetben való részvétel (Egyetemi lapok szerkesztése, Kollégiumi Bizottság, Kollégiumi Stúdió, Külügyi Bizottság, Netclub, Egyetemi Hallgatói Rendezvényszervező Iroda, Helix)
                    if (upload_block.id == "ks4" && upload_block.blocks.length == 0) {
                      _this.$refs["ks4"].setNoOptionMsg('Nyilvántartásban nem szerepel.');
                    }
                  }
                });
              });

              _this.pontUjraszamolas();
            }
          }, 10);

          _this.pontUjraszamolas();

          if(response.hallgato_alapadatok && response.hallgato_atlagok) {
            _this.save_enabled = true;
          } else {
            swal('Hiba!','Hiányos hallgatói adatok.','error');
          }
        }
      }
    });
  },
  computed: {
    elozo_tanev: function() {
      if(this.form.prev_academic_year) {
        return '(' + this.form.prev_academic_year + ')';
      } else {
        return '';
      }
    }
  },
  methods: {
    tmdkLekerdezese: function() {
      var _this = this;

      if (_this.$refs['st2'] == undefined)
        return;

      // Kiválasztott szak alapján lekérdezi a tmdk-at
      this.$root.ajax('hallgato_tmdk/', {
        method: 'POST',
        data: {
          szakkod: this.hallgato_alapadatok_t[this.szak_combo_index].szakkod
        },
        success: function(response) {
          if (response.error) {
            alert(response.error);

          } else {
            // Kiválasztott szak aktív félévének száma
            var aktiv_felevek_szama = _this.hallgato_alapadatok_t[_this.szak_combo_index].aktiv_felevek_szama;

            // tmdk blokk resetelése
            _this.$refs['st2'].reset();

            var has_tmdk = false;

            _this.form.fields.map(function(field) {
              if (field.name == 'st2') {
                field.options.map(function(opt) {
                  opt.show = 0;

                  response.tmdks.map(function(tmdk) {
                    // Lekeresi a helyezés alapján a combó value-t, és hozzáad egy új blokkot
                    if (opt.text == tmdk.helyezes) {
                      // Csak a tárgyfélévben vagy az azt megelőző félévben végzett, megfelelően igazolt, szakmai tevékenység esetén
                      //if (aktiv_felevek_szama == tmdk.aktiv_felevek_szama || (aktiv_felevek_szama - 1) == tmdk.aktiv_felevek_szama) {
                        _this.$refs['st2'].changeComboValue(opt.value);
                        _this.$refs['st2'].addBlock(['ktr_autofill.jpg']);
                        has_tmdk = true;
                      //}
                    }
                  });
                });
              }
            });

            if (!has_tmdk)
              _this.$refs['st2'].setNoOptionMsg('Nyilvántartásban nem szerepel.');
            else
              _this.$refs['st2'].clearNoOptionMsg();

            _this.pontUjraszamolas();
          }
        }
      });
    },

    otdkLekerdezese: function() {
      var _this = this;

      if (_this.$refs['st1'] == undefined)
        return;

      // Kiválasztott szak alapján lekérdezi az otdk-at
      this.$root.ajax('hallgato_otdk/', {
        method: 'POST',
        data: {
          szakkod: this.hallgato_alapadatok_t[this.szak_combo_index].szakkod
        },
        success: function(response) {
          if (response.error) {
            alert(response.error);

          } else {
            // Kiválasztott szak aktív félévének száma
            var aktiv_felevek_szama = _this.hallgato_alapadatok_t[_this.szak_combo_index].aktiv_felevek_szama;

            // blokk resetelése
            _this.$refs['st1'].reset();

            var has_otdk = false;

            _this.form.fields.map(function(field) {
              if (field.name == 'st1') {
                field.options.map(function(opt) {
                  opt.show = 0;

                  response.otdks.map(function(otdk) {
                    // Lekeresi a helyezés alapján a combó value-t, és hozzáad egy új blokkot
                    if (opt.text == otdk.helyezes) {
                      // Csak a tárgyfélévben vagy az azt megelőző félévben végzett, megfelelően igazolt, szakmai tevékenység esetén
                      //if (aktiv_felevek_szama == otdk.aktiv_felevek_szama || (aktiv_felevek_szama - 1) == otdk.aktiv_felevek_szama) {
                        _this.$refs['st1'].changeComboValue(opt.value);
                        _this.$refs['st1'].addBlock(['ktr_autofill.jpg']);
                        has_otdk = true;
                      //}
                    }
                  });
                });
              }
            });

            if (!has_otdk)
              _this.$refs['st1'].setNoOptionMsg('Nyilvántartásban nem szerepel.');
            else
              _this.$refs['st1'].clearNoOptionMsg();

            _this.pontUjraszamolas();
          }
        }
      });
    },

    getFieldByName: function(field_name) {
      var f;
      this.form.fields.map(function(field) {
        if (field.name == field_name)
          f = field;
      });
      return f;
    },

    save: function(veglegesit) {
      var _this = this;

      this.errors = [];

      // elmenti az UploadHandlerWithComboAddRemove blokkok struktúráját
      var upload_blocks = [];
      ["st1", "st2", "st3", "st4", "st5", "st6", "st7", "st8", "ks1", "ks2", "ks3", "ks4", "ks5", "ks6", "ks7", "nyelvtudas"].map(function(id) {
        if (_this.$refs[id] != undefined) {
          upload_blocks.push({id: id, blocks: _this.$refs[id].getBlocksToSave()});
        }
      });
      this.form.upload_blocks = upload_blocks;

      this.$root.ajax('form/nemzeti_felsooktatasi_osztondij_kitoltes_mentes/', {
        method: 'POST',
        data: {
          form: JSON.stringify(this.form),
          osztondijindex_pont: _this.osztondijindex_pont,
          idegennyelv_pont: _this.idegennyelv_pont,
          tanulmanyok_pont: _this.tanulmanyok_pont,
          tanulmanyok_max_pont: _this.tanulmanyok_max_pont,
          szakmaitevekenyseg_pont: _this.szakmaitevekenyseg_pont,
          szakmaitevekenyseg_max_pont: _this.szakmaitevekenyseg_max_pont,
          kozelet_sport_pont: _this.kozelet_sport_pont,
          kozelet_sport_max_pont: _this.kozelet_sport_max_pont,
          ossz_pont: _this.ossz_pont,
          ossz_max_pont: _this.ossz_max_pont,
          veglegesit: veglegesit
        },
        success: function(response) {
          if (response.errors != undefined && response.errors.length > 0) {
            _this.errors = response.errors;

            Vue.nextTick(function() {
              $('html, body').animate({
                scrollTop: $('#' + _this.errors[0].id).offset().top - 50
              }, 500);
            })

          } else if (response.error) {
            swal('Hiba!', response.error, 'error');

          } else {
            _this.fill_info = response.fill_info;
          }
        }
      });
    },

    kozelet_sport_max_pontCalc: function() {
      // maximum a tanulmányokért és a szakmai tevékenységért kapott pontok összegének 1/9-ed része kerekítés szabályai szerint
      this.kozelet_sport_max_pont = Math.round((this.tanulmanyok_pont + this.szakmaitevekenyseg_pont) * (1/9));

      if (this.kozelet_sport_pont > this.kozelet_sport_max_pont)
        this.kozelet_sport_pont = this.kozelet_sport_max_pont;
    },

    ossz_pontCalc: function() {
      this.ossz_pont = this.tanulmanyok_pont + this.szakmaitevekenyseg_pont + this.kozelet_sport_pont;
    },

    max_ossz_pontCalc: function() {
      this.ossz_max_pont = this.tanulmanyok_max_pont + this.szakmaitevekenyseg_max_pont + this.kozelet_sport_max_pont;
    },

    tanulmanyok_pontCalc: function() {
      this.tanulmanyok_pont = this.idegennyelv_pont + this.osztondijindex_pont;
    },

    idegennyelv_pontCalc: function() {
      var _this = this;
      var p = 0;

      if (Array.isArray(_this.form.values.nyelvtudas)) {
        _this.form.values.nyelvtudas.map(function(item_) {
          // Ha van fájfeltöltés a combó értéknél
          if (item_.files.length > 0) {
            // Pontszám lekérése
            _this.form.fields.map(function(field) {
              if (field.name == "nyelvtudas") {
                field.options.map(function(opt) {
                  if (parseInt(opt.value) == parseInt(item_.id))
                    p += parseInt(opt.point);
                });
              }
            });
          }
        });
      }

      if (p > this.idegennyelv_max_pont)
        p = this.idegennyelv_max_pont;

      this.idegennyelv_pont = p;
    },

    szakmaitevekenyseg_pontCalc: function() {
      var _this = this;
      var p = 0;
      var arr = ["st1", "st2", "st3", "st4", "st5", "st6", "st7", "st8"];

      arr.map(function(name) {
        if (Array.isArray(_this.form.values[name])) {
          _this.form.values[name].map(function(block) {
            if (block.files.length > 0) {

              // Pontszám lekérése
              _this.form.fields.map(function(field) {
                if (field.name == name) {
                  field.options.map(function(opt) {
                    if (parseInt(opt.value) == parseInt(block.id))
                      p += parseInt(opt.point);
                  });
                }
              });
            }
          });
        }
      });

      if (p > this.szakmaitevekenyseg_max_pont)
        p = this.szakmaitevekenyseg_max_pont;

      this.szakmaitevekenyseg_pont = p;
    },

    sor_pontCalc: function(field_name) {
      var _this = this;
      var p = 0;

      if (this.form.fields.length == 0)
        return 0;

      this.form.fields.map(function(field) {
        if (field.name == field_name) {
          field.options.map(function(opt) {
            if (Array.isArray(_this.form.values[field.name])) {
              _this.form.values[field.name].map(function(block) {
                if (parseInt(block.id) == parseInt(opt.value) && block.files.length > 0) {
                  p += parseInt(opt.point);
                }
              });
            }
          });
        }
      });

      return p;
    },

    sor_pontokCalc: function() {
      var _this = this;

      var arr = ["st1", "st2", "st3", "st4", "st5", "st6", "st7", "st8", "ks1", "ks2", "ks3", "ks4", "ks5", "ks6", "ks7"];
      arr.map(function(field_name) {
        _this.sor_pontok[field_name] = _this.sor_pontCalc(field_name);
      });

    },

    kozelet_sport_pontCalc: function() {
      var _this = this;
      var p = 0;
      var arr = ["ks1", "ks2", "ks3", "ks4", "ks5", "ks6", "ks7"];

      arr.map(function(name) {
        if (Array.isArray(_this.form.values[name])) {
          _this.form.values[name].map(function(block) {
            if (block.files.length > 0) {

              // Pontszám lekérése
              _this.form.fields.map(function(field) {
                if (field.name == name) {
                  field.options.map(function(opt) {
                    if (parseInt(opt.value) == parseInt(block.id))
                      p += parseInt(opt.point);
                  });
                }
              });
            }
          });
        }
      });

      if (p > this.kozelet_sport_max_pont)
        p = this.kozelet_sport_max_pont;

      this.kozelet_sport_pont = p;
    },

    changeValue: function(value, name) {
      this.form.values[name] = value;
      this.pontUjraszamolas();
    },

    pontUjraszamolas: function() {
      this.sor_pontokCalc();
      this.idegennyelv_pontCalc();
      this.tanulmanyok_pontCalc();
      this.szakmaitevekenyseg_pontCalc();
      this.kozelet_sport_max_pontCalc();
      this.kozelet_sport_pontCalc();

      this.max_ossz_pontCalc();
      this.ossz_pontCalc();
    },

    szakValt: function(index, tmdk_beallitas, otdk_beallitas) {
      this.form.hallgato_alapadatok = this.hallgato_alapadatok_t[index];
      this.form.hallgato_atlagok = this.hallgato_atlagok_t[index];
      this.osztondijindex_pont = this.form.hallgato_atlagok.atlag * 100;
      this.pontUjraszamolas();

      if (tmdk_beallitas) {
        this.tmdkLekerdezese();
      }

      if (otdk_beallitas) {
        this.otdkLekerdezese();
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// nemzeti_felsooktatasi_osztondij.vue?69932ef8